// Agent credit helpers. The period reset itself runs on the server
// (company/rolloverSubscription).

export const AGENT_CREDITS_EXHAUSTED = "AGENT_CREDITS_EXHAUSTED";
export const AGENT_CREDITS_EXHAUSTED_MESSAGE =
  "Your monthly credits are finished. Please contact to your administrator";

export function readAgentBalances(userCompany) {
  const agent = (userCompany && userCompany.agent) || {};
  const plan = agent.plan || {};
  const credit = Number(agent.credit) || 0;
  const extraCredit = Number(agent.extraCredit) || 0;
  const promotionCredit = Number(agent.promotionCredit) || 0;
  const monthlyCredit = Number(plan.monthlyCredit) || 0;
  const totalSpendable = credit + extraCredit + promotionCredit;

  return {
    credit,
    extraCredit,
    promotionCredit,
    monthlyCredit,
    totalSpendable,
  };
}

export function hasAgentCreditsRemaining(userCompany) {
  return readAgentBalances(userCompany).totalSpendable > 0;
}

export function notifyAgentCreditsExhausted(createSnackbar) {
  if (typeof createSnackbar === "function") {
    createSnackbar(AGENT_CREDITS_EXHAUSTED_MESSAGE, "warning");
  }
}

export function isAgentCreditsExhaustedError(err) {
  if (!err) return false;
  return err.code === AGENT_CREDITS_EXHAUSTED || err.message === AGENT_CREDITS_EXHAUSTED_MESSAGE;
}

/** Toast for server-side exhausted credits; returns true when handled. */
export function handleAgentCreditsExhaustedError(err, createSnackbar) {
  if (!isAgentCreditsExhaustedError(err)) return false;
  notifyAgentCreditsExhausted(createSnackbar);
  return true;
}

/** Next standard-credit refill — midnight local on the day after the current period ends. */
export function getAgentCreditRenewalDate(userCompany) {
  const periods = userCompany?.subscription?.periods;
  if (!periods || periods.length === 0) return null;

  const endDate = new Date(periods[periods.length - 1].endDate);
  if (Number.isNaN(endDate.getTime())) return null;

  const renewal = new Date(endDate);
  renewal.setDate(renewal.getDate() + 1);
  renewal.setHours(0, 0, 0, 0);
  return renewal;
}

export function formatAgentCreditDate(date) {
  if (!date || Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}
